import React from 'react';
import { find, get } from 'lodash';
import { Translate, useTranslate } from 'core/translate';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import useLargeBreakpoint from '../../../hooks/useLargeBreakpoint';
import { combineClassNames } from '../../../../core/css';

const PaymentEstimatorTabs = ({ defaultTabIndex, onClose, ctas }) => {
  const translate = useTranslate();
  const isAtLeastLarge = useLargeBreakpoint();
  const locateDealerUrl = get(find(ctas, { key: 'lad' }), 'url');

  const gridTabPanel = (
    <TabPanel className="byo-tabs__panel">
      <div className="pe-grid-tabs">
        <div className="pe-financebox__wrapper">
          <gmst-pe-financebox />
          <button
            className="button button--primary stat-button-link pe-financebox__button"
            data-dtm="finance"
            onClick={onClose}>
            <Translate value="select" />
          </button>
        </div>
        <div className="pe-leasebox__wrapper">
          <gmst-pe-leasebox />
          <button
            className="button button--primary stat-button-link pe-leasebox__button"
            data-dtm="lease"
            onClick={onClose}>
            <Translate value="select" />
          </button>
        </div>
      </div>
    </TabPanel>
  );

  return (
    <Tabs
      defaultIndex={defaultTabIndex}
      className="byo-tabs"
      selectedTabClassName="byo-tabs__tab--active"
      selectedTabPanelClassName="byo-tabs__panel--selected">
      <TabList className="byo-tabs__tablist">
        <Tab
          className={combineClassNames(
            'byo-tabs__tab',
            isAtLeastLarge ? 'byo-tabs__tab--active' : ''
          )}>
          <div className="byo-tabs__tab-label">
            <Translate value="component.pricing.finance.header" />
          </div>
        </Tab>
        <Tab
          className={combineClassNames(
            'byo-tabs__tab',
            isAtLeastLarge ? 'byo-tabs__tab--active' : ''
          )}>
          <div className="byo-tabs__tab-label">
            <Translate value="component.pricing.lease.header" />
          </div>
        </Tab>
      </TabList>
      {isAtLeastLarge ? (
        <>
          {gridTabPanel}
          {gridTabPanel}
        </>
      ) : (
        <>
          <TabPanel
            className="byo-tabs__panel"
            selectedTabPanelClassName="byo-tabs__panel--selected">
            <div className="pe-financebox__wrapper">
              <gmst-pe-financebox />
              <button
                className="button button--primary stat-button-link"
                data-dtm={translate('component.pricing.finance.header')}
                onClick={onClose}>
                <Translate value="select" />
              </button>
            </div>
          </TabPanel>
          <TabPanel
            className="byo-tabs__panel"
            selectedTabPanelClassName="byo-tabs__panel--selected">
            <div className="pe-leasebox__wrapper">
              <gmst-pe-leasebox>
                <span slot="localDealer">
                  <a
                    href={locateDealerUrl}
                    className="pe-leasebox__link stat-button-link"
                    data-dtm="lease">
                    <gm-translate>leasebox.localDealer</gm-translate>
                  </a>{' '}
                </span>
              </gmst-pe-leasebox>
              <button
                className="button button--primary stat-button-link"
                data-dtm={`${translate(
                  'component.pricing.payments.header'
                )}:lease`}
                onClick={onClose}>
                <Translate value="select" />
              </button>
            </div>
          </TabPanel>
        </>
      )}
    </Tabs>
  );
};

export default PaymentEstimatorTabs;
